export default "CREATE INDEX IF NOT EXISTS `idx_pending_notifications_created_at` ON `pending_notifications` (`created_at`);";